import { LockedModal, ModalForm, PageTitle } from 'modules/app/styles'
import { getPageSharingConfig_api, getPageSharing_api, requestUnlock_api } from 'store/apis'
import { ResponseEditor } from 'modules/response/styles'
import React, { useEffect, useState } from 'react'
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { useParams } from 'react-router-dom'
import { getTitle, handleApiError, logAmplitudeEvent, uuidExtract } from 'utils/helpers'
import { ErrorPage404, SharedPageFooter, SharedPageTitle } from '../styles'
import { ReactComponent as Logo } from 'assets/images/klutch-logo.svg'
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import { CustomButton, EyeIcon, LoginInput } from 'modules/auth/styles'
import { history } from 'store/store'
import { ButtonLoader, getUserData, PageLoader } from 'utils/storageUtils'
import { connect } from 'react-redux'
import { ReactComponent as LockModalSvg } from 'assets/images/locked_file.svg'
import { ReactComponent as LockIcon } from 'assets/images/icons/lock.svg'
import { BsEye, BsEyeSlash } from 'react-icons/bs'
import { toast } from 'react-toastify'
import CatContentCover from 'modules/contents/CatContentCover'

function setCookie(_sharingUUID, password) {
  const d = new Date()
  d.setTime(d.getTime() + 1 * 3600 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = _sharingUUID + '=' + password + ';' + expires
}

function getCookie(_sharingUUID) {
  let name = _sharingUUID + '='
  let decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

const SharedPage = () => {
  const { uuid } = useParams()
  const [page, set_page] = useState({})
  const [show_password_modal, set_show_password_modal] = useState(false)
  const [password, set_password] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [sharingUUID, setSharingUUDI] = useState()
  const [user, setUser] = useState()
  const [isnot_accessible, set_isnot_accessible] = useState(false)
  const [is_password_checking, set_is_password_checking] = useState(false)
  const [hasError, set_hasError] = useState(null)
  const [passwordVisible, setPasswordVisible] = useState(false)
  const [unLockRequest_loading, setUnLockRequest_loading] = useState(false)
  const [pageError, setPageError] = useState(false)
  const [is_Active, set_is_Active] = useState(false)

  useEffect(() => {
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:hide'])
    }
    setSharingUUDI(uuidExtract(uuid))
  }, [uuid])

  const checkPassword = async (e) => {
    try {
      e.preventDefault()
      set_is_password_checking(true)
      if (password.trim() !== '') {
        const result = await getPageSharing_api(sharingUUID, password)
        set_page(result)
        set_show_password_modal(false)
        setCookie(sharingUUID, password)
      } else {
        set_hasError('Enter password')
      }
    } catch (e) {
      handleApiError(e)
    }
    set_is_password_checking(false)
  }
  const getPageShare = async (_sharingUUID) => {
    setIsLoading(true)
    const userData = getUserData()
    setUser(userData)
    try {
      const result = await getPageSharingConfig_api(_sharingUUID)
      set_isnot_accessible(!result.company.isFree && !result.company.isOnGracePeriod && !result.company.is_subscribed)
      set_is_Active(result.is_accessible)
      if (userData && userData.id) {
        history.push(`/page/${result.uuid}`)
      } else {
        if (result.is_password_set) {
          const is_password = getCookie(_sharingUUID)
          if (is_password) {
            const data = await getPageSharing_api(_sharingUUID, is_password)
            set_page(data)
          } else {
            set_show_password_modal(true)
          }
        } else if (result.is_accessible) {
          const data = await getPageSharing_api(_sharingUUID)
          set_show_password_modal(false)
          set_page(data)
        }
      }
    } catch (e) {
      setPageError(true)
    }
    setIsLoading(false)
  }

  const requestToUnlock = async () => {
    try {
      setUnLockRequest_loading(true)
      const response = await requestUnlock_api(sharingUUID)
      toast.success(response.message)
      logAmplitudeEvent('Request send successfully!')
    } catch (e) {
      handleApiError(e)
    }
    setUnLockRequest_loading(false)
  }
  useEffect(() => {
    if (sharingUUID) {
      getPageShare(sharingUUID)
    }
  }, [sharingUUID])
  return (
    <>
      {!user && !pageError && (
        <div className='position-relative bg-white'>
          {isLoading ? (
            <div className='d-flex  vh-100 justify-content-center align-items-center'>
              <PageLoader />
            </div>
          ) : (
            <>
              <SharedPageTitle>
                <div className='logo'>
                  {page.company?.logo && (
                    <div className={`${page.company.logo ? 'has-company-logo' : ''}`}>
                      <img src={page.company.logo} alt='logo' />
                    </div>
                  )}
                  <div className='company-name'> {page.company?.name} </div>
                </div>
              </SharedPageTitle>

              <div className='d-flex justify-content-center position-relative mt-5'>
                {isnot_accessible || !is_Active ? (
                  <Modal centered fade={false} size='md' isOpen={true}>
                    <LockedModal>
                      <ModalBody className='modal-body container'>
                        <div className='title'>
                          <LockModalSvg />
                          You Don't Have Access
                        </div>
                        <p>This page is locked. Please contact the admin by clicking on the button below and try again later.</p>
                        <CustomButton className='black mx-3' onClick={requestToUnlock}>
                          <span className='lockIcon'>
                            <LockIcon />
                          </span>
                          Request Access
                          {unLockRequest_loading && <ButtonLoader />}
                        </CustomButton>
                      </ModalBody>
                    </LockedModal>
                  </Modal>
                ) : (
                  <ResponseEditor className='page'>
                    <div className='position-relative' style={{ zIndex: 1 }}>
                      <div className='spacer'>
                        <CatContentCover row={page}
                          resourceCover={page?.cover ?? page?.cover_media}
                          resourceIcon={page?.icon ?? page?.icon_media}
                          type={'content'}
                          setLastFetchToken={() => null}
                          id={page?.id}
                          isEditable={false} />

                      </div>
                      <div className='spacer'>
                        <PageTitle>
                          <span dir='auto'>{getTitle(page.title)}</span>
                        </PageTitle>
                        <div className='published-page content-wrapper mb-5'>
                          <div className='fr-box'>
                            <div className='fr-wrapper'>
                              <FroalaEditorView model={page.content} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ResponseEditor>
                )}
              </div>
            </>
          )}
          <SharedPageFooter>
            <div className='divider' />
            <span className='footerText'>
              Create your knowledge base with{' '}
              <a href='https://klutch.app/?utm_source=credit'>
                <Logo height={24} width={57} />
              </a>
            </span>
          </SharedPageFooter>
        </div>
      )}
      {!isnot_accessible && !isLoading && !user && show_password_modal && (
        <Modal centered fade={false} size='md' isOpen={show_password_modal}>
          <ModalForm onSubmit={checkPassword} autoComplete='off'>
            <ModalBody className='pt-5 modal-body'>
              <div className='d-flex justify-content-between'>
                <div className='title'> Password </div>
              </div>
              <LoginInput
                type={passwordVisible ? 'text' : 'password'}
                id='password'
                className={`login-input ${password.trim() !== '' ? 'has-value' : ''}`}
                value={password}
                onChange={(e) => set_password(e.target.value)}
                placeholder='Password'
              />
              {password.trim() !== '' && (
                <EyeIcon style={{ top: '110px', right: '40px' }} onClick={() => setPasswordVisible(!passwordVisible)}>
                  {!passwordVisible ? <BsEye size={20} /> : <BsEyeSlash size={20} />}
                </EyeIcon>
              )}
              {hasError && <div className='error-message w-100'> {hasError} </div>}
            </ModalBody>
            <ModalFooter className='d-flex justify-content-center align-items-center'>
              <CustomButton className='black mx-3'>
                Submit
                {is_password_checking && <ButtonLoader />}
              </CustomButton>
            </ModalFooter>
          </ModalForm>
        </Modal>
      )}
      {pageError && (
        <ErrorPage404>
          <p className='text404'>404</p>
          <p className='not-found'>Page Not Found</p>
        </ErrorPage404>
      )}
    </>
  )
}
export default connect(null, null)(SharedPage)
